/* eslint-disable react/forbid-prop-types */
/* eslint-disable max-len */
/* eslint-disable no-console */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import XLSX from 'xlsx';
import moment from 'moment';
import PropTypes from 'prop-types';
import HeaderStatistics from './HeaderStatistics';
import CasesStatistics from './CasesStatistics';
import QuotationsStatistics from './QuotationsStatistics';
import ExecutivesStatistics from './ExecutivesStatistics';
import { getAllCasesDashboard, getCaseDataExport } from '../../../redux/actions/casesActions';
import { getAllQuotationsDashboard, getQuotationDataExport } from '../../../redux/actions/quotationsActions';
import { changeTitleAction } from '../../../redux/actions/topbarActions';
import { getAllUsersDashboard } from '../../../redux/actions/userActions';
import LoadingScreen from './LoadingScreen';

const propTypes = {
  dataDashboardCases: PropTypes.object.isRequired,
  dataDashboardQuot: PropTypes.object.isRequired,
  dataDashboardUsers: PropTypes.array.isRequired,
  getAllCasesDashboard: PropTypes.func.isRequired,
  getAllQuotationsDashboard: PropTypes.func.isRequired,
  getAllUsersDashboard: PropTypes.func.isRequired,
  getCaseDataExport: PropTypes.func.isRequired,
  getQuotationDataExport: PropTypes.func.isRequired,
  gettingDataDashboardCases: PropTypes.bool.isRequired,
  gettingDataDashboardQuot: PropTypes.bool.isRequired,
  gettingDataDashboardUsers: PropTypes.bool.isRequired,
  setTitle: PropTypes.func.isRequired,
  casesExportedData: PropTypes.shape({
    loading: PropTypes.bool,
  }),
  quotationExportedData: PropTypes.shape({
    loading: PropTypes.bool,
  })
};

class MiPanelContent extends Component {
  state = {
    fromDateCase: undefined,
    toDateCase: undefined,
    fromDateQuotation: undefined,
    toDateQuotation: undefined,
  };

  componentDidMount() {
    this.props.setTitle('Mi Panel');
    this.props.getAllCasesDashboard({}, (body) => {
      const {
        fromDate,
        toDate,
      } = body;
      this.setState({ fromDateCase: fromDate, toDateCase: toDate });
    });
    this.props.getAllQuotationsDashboard({}, (body) => {
      const {
        fromDate,
        toDate,
      } = body;
      this.setState({ fromDateQuotation: fromDate, toDateQuotation: toDate });
    });
    this.props.getAllUsersDashboard();
  }

  componentWillUnmount() {
    this.props.setTitle('');
  }

  onChangeCasesPeriod = (key, value) => {
    if (key === 'fromDate') {
      this.setState({ fromDateCase: moment(value).format('DD-MM-YYYY') });
    } else {
      this.setState({ toDateCase: moment(value).format('DD-MM-YYYY') });
    }
  }

  onChangeQuotationPeriod = (key, value) => {
    if (key === 'fromDate') {
      this.setState({ fromDateQuotation: moment(value).format('DD-MM-YYYY') });
    } else {
      this.setState({ toDateQuotation: moment(value).format('DD-MM-YYYY') });
    }
  }

  onClickConsolte = key => () => {
    const {
      fromDateCase,
      toDateCase,
      fromDateQuotation,
      toDateQuotation,
    } = this.state;

    if (key === 'cases') {
      const query = { fromDate: fromDateCase, toDate: toDateCase };
      this.props.getAllCasesDashboard(query);
    } else {
      const query = { fromDate: fromDateQuotation, toDate: toDateQuotation };
      this.props.getAllQuotationsDashboard(query);
    }
  }

  onClickExportCases = () => {
    const { fromDateCase, toDateCase } = this.state;
    this.props.getCaseDataExport({ fromDateCase, toDateCase }, data => this.exportExcel('Casos', { fromDate: fromDateCase, toDate: toDateCase }, data));
  }

  onClickExportQuotation = () => {
    const { fromDateQuotation, toDateQuotation } = this.state;
    this.props.getQuotationDataExport({ fromDateQuotation, toDateQuotation }, data => this.exportExcel('Cotizaciones', { fromDate: fromDateQuotation, toDate: toDateQuotation }, data));
  }

  exportExcel = (target, { fromDate: f, toDate: t }, data = []) => {
    try {
      const ws = XLSX.utils.json_to_sheet(data);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, target);
      XLSX.writeFile(wb, `${target.toLowerCase()}_${f.replace(/-/gi, '_')}_al_${t.replace(/-/gi, '_')}.xlsx`);
    } catch (e) {
      console.error('export error');
    }
  }

  render() {
    const {
      dataDashboardCases,
      gettingDataDashboardCases,
      dataDashboardQuot,
      gettingDataDashboardQuot,
      dataDashboardUsers,
      gettingDataDashboardUsers,
      casesExportedData,
      quotationExportedData
    } = this.props;

    return (
      <div className="dashboard container">
        <div className="section casos">
          {(casesExportedData.loading || quotationExportedData.loading) &&
            <LoadingScreen description={'Generando y Descargando Excel...'} />
          }
          <HeaderStatistics
            title="Casos"
            hasToolbar="yes"
            onChange={this.onChangeCasesPeriod}
            onClickExport={this.onClickExportCases}
            loadingData={casesExportedData}
            fromDate={this.state.fromDateCase}
            toDate={this.state.toDateCase}
            disable={gettingDataDashboardCases}
            onClickConsolte={this.onClickConsolte('cases')}
          />
          <CasesStatistics body={dataDashboardCases} onClickExport={this.onClickExportCases} />
        </div>
        <div className="section">
          <HeaderStatistics
            title="Cotizaciones"
            hasToolbar="yes"
            onChange={this.onChangeQuotationPeriod}
            onClickExport={this.onClickExportQuotation}
            loadingData={quotationExportedData}
            fromDate={this.state.fromDateQuotation}
            toDate={this.state.toDateQuotation}
            disable={gettingDataDashboardQuot}
            onClickConsolte={this.onClickConsolte('quotations')}
          />
          <QuotationsStatistics body={dataDashboardQuot} />
        </div>
        <div className="section ejecutivos">
          <div className="section-header">
            <div className="section-title">
              <h2>Ejecutivos</h2>
            </div>
          </div>
          <ExecutivesStatistics
            body={dataDashboardUsers}
            disable={gettingDataDashboardUsers}
            order="asc"
            orderBy="name"
          />
        </div>
      </div>
    );
  }
}

MiPanelContent.propTypes = propTypes;

const mapStateToProps = ({ cases, quotations, users }) => ({
  dataDashboardCases: cases.dataDashboard,
  dataDashboardQuot: quotations.dataDashboard,
  dataDashboardUsers: users.dataDashboard,
  gettingDataDashboardCases: cases.gettingDataDashboard,
  gettingDataDashboardQuot: quotations.gettingDataDashboard,
  gettingDataDashboardUsers: users.gettingDataDashboard,
  casesExportedData: cases.exportedData,
  quotationExportedData: quotations.exportedData,
});

const mapDispatchToProps = {
  changeTitleAction,
  setTitle: changeTitleAction,
  getAllCasesDashboard,
  getAllQuotationsDashboard,
  getCaseDataExport,
  getQuotationDataExport,
  getAllUsersDashboard,
};
export default connect(mapStateToProps, mapDispatchToProps, null, { forwardRef: true })(MiPanelContent);
